import React from 'react';
import { Link } from 'react-router-dom';
import { KollabHRFullLogo } from '@gokrew/ui/assets';
import LanguageSwitcher from '@gokrew/ui/components/LanguageSwitcher';
import { setIntentionalLanguage } from '@gokrew/ui/utility/intentional-language';
import { BrandPanel } from './BrandPanel';
import styles from './AuthV2Layout.module.css';

interface AuthV2LayoutProps {
  children: React.ReactNode;
  brandFooter?: React.ReactNode;
}

export function AuthV2Layout({ children, brandFooter }: AuthV2LayoutProps) {
  return (
    <div className={styles.shell}>
      <div className={styles.brandCol}>
        <BrandPanel footer={brandFooter} />
      </div>
      <div className={styles.formCol}>
        <div className={styles.topBar}>
          <Link to="/login" className={styles.mobileLogoLink}>
            <img
              src={KollabHRFullLogo}
              alt="KollabHR"
              className={styles.mobileLogo}
            />
          </Link>
          <div className={styles.langWrap}>
            {/* Always shown: the language picked here carries through the
                verification email, the account and onboarding. */}
            <LanguageSwitcher
              alwaysVisible
              onLanguageChange={setIntentionalLanguage}
            />
          </div>
        </div>
        {children}
      </div>
    </div>
  );
}
